import React from 'react';
import RumTableTemplate from '../templates/RumTable';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Actions } from '../../store/actions/liberty';
import { AnomalyActions } from '../../store/actions/anomalyDetection';

class LibertyRumTable extends React.PureComponent {
  render() {
    let anomalyData = [];
    if (this.props.anomalyData) {
      anomalyData = this.props.anomalyData;
    }
    const { loading, anomalyDataloading } = this.props;
    return (
      <RumTableTemplate
        {...this.props}
        fetchData={this.props.fetchData}
        loading={loading}
        showDaily={true}
        prefix="liberty"
        anomalyData={anomalyData}
        anomalyDataloading={anomalyDataloading}
        fetchDailyAnomalyReport={this.props.fetchDailyAnomalyReport}
      />
    );
  }
}

LibertyRumTable.propTypes = {
  data: PropTypes.array,
  fetchData: PropTypes.func,
  loading: PropTypes.bool,
  summaryData: PropTypes.object,
  anomalyDataloading: PropTypes.bool,
  anomalyData: PropTypes.array,
  fetchDailyAnomalyReport: PropTypes.func
};

function mapStateToProps(state) {
  return {
    data: state.liberty.rumData.data,
    loading: state.liberty.rumData.loading,
    summaryData: state.liberty.rumData.summaryData,
    anomalyDataloading: state.anomalyDetection.anomalyDailyReport.loading,
    anomalyData: state.anomalyDetection.anomalyDailyReport.anomalyData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchData() {
      return dispatch(Actions.fetchRumData());
    },
    fetchDailyAnomalyReport(service, platform, date) {
      return dispatch(
        AnomalyActions.fetchDailyAnomalyReport(service, platform, date)
      );
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LibertyRumTable);
